import * as React from 'react';
import { GlobalStyles } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import { Close } from '@mui/icons-material';
import { styled } from '@mui/material/styles';
import Button from '../Button';

const MuiDialog = styled(Dialog)<{ width: number }>`
  min-height: 900px;
  min-width: 980px;
}))`;

const StyledDialogTitle = styled(DialogTitle)`
  justify-content: space-between;
  button {
    float: right;
  }
`;

export interface DialogTitleProps {
  id: string;
  children?: React.ReactNode;
  onClose: () => void;
}

const MuiDialogTitle = (props: DialogTitleProps) => {
  const { children, onClose, ...other } = props;

  return (
    <StyledDialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton aria-label="close" onClick={onClose}>
          <Close />
        </IconButton>
      ) : null}
    </StyledDialogTitle>
  );
};

export default function CustomizedDialogs({
  open,
  title,
  content,
  onConfirm,
  onClose,
  confirmText,
  showFooter = true,
  cancelText = 'Cancel',
  showCancelButton = true,
  width = 600,
}: any) {
  return (
    <MuiDialog disableScrollLock onClose={onClose} aria-labelledby="customized-dialog-title" open={open} width={width}>
      <GlobalStyles
        styles={{
          '.MuiDialog-container': {
            '.MuiSvgIcon-root': {
              marginTop: '-4px',
            },
            '.MuiDialogTitle-root': {
              color: 'var(--color-gray-1)',
              fontSize: 18,
              fontWeight: 'bold',
              marginTop: '10px',
              marginLeft: '8px',
            },
            '. MuiDialogActions-root': {
              flex: '0 0 0',
              justifyContent: 'flex-end',
            },
            '.MuiButton-root': {
              width: 'unset',
              minWidth: '96px',
            },
            '.MuiDialogActions-root>:not(:first-of-type)': {
              marginLeft: 0,
            },
            '.MuiDialogContent-root': {
              minHeight: '160px',
              maxHeight: '100%',
              display: 'flex',
              alignItems: 'center',
              padding: '0 !important',
            },
            '.MuiDialog-paper': {
              minWidth: width,
              maxWidth: width,
            },
          },
        }}
      />
      <MuiDialogTitle id="customized-dialog-title" onClose={onClose}>
        {title}
      </MuiDialogTitle>
      <DialogContent dividers>{content}</DialogContent>
      {showFooter && (
        <DialogActions>
          {showCancelButton && (
            <Button size="large" secondary onClick={onClose}>
              {cancelText}
            </Button>
          )}
          <Button size="large" autoFocus onClick={onConfirm}>
            {confirmText}
          </Button>
        </DialogActions>
      )}
    </MuiDialog>
  );
}
